import { Component, Input } from '@angular/core';
import { LegalDocumentType } from '@ktypes/models';

/** Note: requires the includeProMedica and includeTrademark attributes to be passed */
@Component({
  selector: 'kp-landing-footer[includeProMedica][includeTrademark]',
  templateUrl: './landing-footer.component.html',
  styleUrls: ['./landing-footer.component.scss'],
})
export class LandingFooterComponent {
  @Input() includeProMedica: boolean;
  @Input() includeTrademark: boolean;
  legalDocumentType = LegalDocumentType;
}
